import Vue from 'vue'
// 表单配置
import { KFormDesign, KFormBuild, OrginRecordWord } from './components/k-form-design/packages/index.js'
import './components/k-form-design/styles/form-design.less'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element, { Loading } from 'element-ui'

import './styles/element-variables.scss'
// import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
// ----引入Antd-------》
// import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import checkPer from '@/utils/permission'
import permission from './components/Permission'

import * as filters from './filters' // global filters
// 数据字典
import dict from './components/Dict'
import VueClipboard from 'vue-clipboard2'
import Vue2OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css'
import VueContextMenu from 'vue-context-menu'
import modelerStore from '@/components/Process/common/global'
Vue.prototype.modelerStore = modelerStore
// vform 表单设计器
import vform from '@/components/vform/VFormDesigner.umd.min.js'
import '@/components/vform/VFormDesigner.css'
// 同时注册了v-form-designer、v-form-render等组件
Vue.use(vform)

// 自定义全局指令
import drag from '../src/components/k-form-design/packages/components/OrginRecordWord/config/drag.js' // 引入插件
Vue.use(drag)
Vue.use(VueContextMenu)

Vue.use(Vue2OrgTree)

Vue.use(VueClipboard)

Vue.use(Loading)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }
Vue.use(KFormDesign)
Vue.use(KFormBuild)
Vue.use(OrginRecordWord)
Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale: locale // import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n使用中文，无需设置，请删除
})
// Vue.use(Antd);
Vue.use(checkPer)
Vue.use(permission)
Vue.use(dict)
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

async function initUserInfo() {
  // 假设有 token 判断
  const token = localStorage.getItem('token')
  if (token) {
    await store.dispatch('user/getUserInfo')
  }
}
initUserInfo()

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
